import { useNavigate } from 'react-router-dom';
import React from 'react';

import { createSelfbookHandler } from '../../../utils/selfbook';
import { CTALink } from '../../shared/CTALink/CTALink';
import { images } from '../../shared/assets';
import { useTranslation } from 'react-i18next';

const ReEnergizePanel: React.FC = () => {
  const navigate = useNavigate();
  const handleBooking = createSelfbookHandler(navigate, '/contact/');
  const { t } = useTranslation();

  return (
    <section className="reenergize-panel">
      {/* section 1 */}
      <div className="reenergize-sect reenergize-sect-1">
        <div className="reenergize-sect-1-left">
          <img src={images.reEnergizePage.rectangle1} alt={images.reEnergizePage.rectangle1} />
        </div>

        <div className="reenergize-sect-1-right">
          <div className="reenergize-sect-1-text">
            <h2 className='reenergize-sect-1-title'>{t('pages/reEnergize:treatments.title')}</h2>
            <p className='reenergize-sect-1-description'>{t('pages/reEnergize:treatments.description')}</p>
            <CTALink
              text={t('pages/reEnergize:treatments.button')}
              type="primary"
              color="awasi"
              onClick={handleBooking}
            />
          </div>

          <div className="reenergize-sect-1-right-image">
            <div className="reenergize-sect-1-right-image-inner">
              <img src={images.reEnergizePage.rectangle11} alt={images.reEnergizePage.rectangle11} />
            </div>
          </div>
        </div>
      </div>

      {/* section 2 */}
      <div className="reenergize-sect reenergize-sect-2">
        <img src={images.reEnergizePage.rectangle1} alt={images.reEnergizePage.rectangle1} />
      </div>

      {/* section 3 */}
      <div className="reenergize-sect reenergize-sect-3">

        <div className="reenergize-sect-3-left">
          <div className="reenergize-sect-3-watermark">
            <img src={images.reEnergizePage.reEnergizeWatermark} alt={images.reEnergizePage.reEnergizeWatermark} />
          </div>
          <div className="reenergize-sect-3-content">
            <h3 className='reenergize-sect-3-title'>{t('pages/reEnergize:program.title')}</h3>
            <p className='reenergize-sect-3-description'>
              {t('pages/reEnergize:program.description')}
            </p>
          </div>
        </div>
        <div className="reenergize-sect-3-right">
          <img src={images.reEnergizePage.rectangle1491} className="reenergize-sect-3-img img-1" alt={images.reEnergizePage.rectangle1491} />
          <img src={images.reEnergizePage.rectangle1492} className="reenergize-sect-3-img img-2" alt={images.reEnergizePage.rectangle1492} />
          <img src={images.reEnergizePage.rectangle1493} className="reenergize-sect-3-img img-3" alt={images.reEnergizePage.rectangle1493} />
        </div>
      </div>
    </section>
  );
};

export default ReEnergizePanel;